import interceptorsLoader from './axios-interceptors-loader';
import wixResultInterceptor from './axios-intercept-wix-result';
import baseurlInterceptor from './axios-intercept-baseurl';
import multilingualInterceptor from './axios-intercept-multilingual';
import artifactIdInterceptor from './axios-intercept-artifactid';
import siteRevisionInterceptor from './axios-intercept-site-revision';
import wixHeadersInterceptor from './axios-intercept-wix-headers';
var _defaults = {
  loadInterceptors: true
};
export default (function (axios, _ref) {
  var baseURL = _ref.baseURL,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === void 0 ? _defaults.loadInterceptors : _ref$loadInterceptors,
      lang = _ref.lang,
      locale = _ref.locale,
      isPrimaryLanguage = _ref.isPrimaryLanguage,
      siteInstance = _ref.siteInstance,
      signedInstance = _ref.signedInstance,
      wixCodeApi = _ref.wixCodeApi,
      _ref$shouldAddArtifac = _ref.shouldAddArtifactIdOverride,
      shouldAddArtifactIdOverride = _ref$shouldAddArtifac === void 0 ? false : _ref$shouldAddArtifac;
  axios.defaults.baseURL = baseURL;
  return interceptorsLoader.loadIfNeeded(axios, {
    shouldLoadInterceptors: loadInterceptors,
    interceptors: [wixResultInterceptor, baseurlInterceptor, multilingualInterceptor.getInterceptor({
      lang: lang,
      siteInstance: siteInstance,
      locale: locale,
      isPrimaryLanguage: isPrimaryLanguage
    }), artifactIdInterceptor.getInterceptor({
      shouldAddArtifactIdOverride: shouldAddArtifactIdOverride
    }), siteRevisionInterceptor.getInterceptor({
      wixCodeApi: wixCodeApi
    }), wixHeadersInterceptor.getInterceptor({
      signedInstance: signedInstance
    })]
  });
});